import { useContext, useState } from "react";
import { clearMasterData, getCookie, handleLogOut } from "mmbclient/Common/CommonFunctions";
import { MASTERdATA, WALLET } from "mmbclient/Common/CommonVariable";


const SidebarMenuController = (store) => {
    const masterData = useContext(MASTERdATA);
    const wallet = useContext(WALLET);

    const [sidebar, setSidebar] = useState(false);

    // State to track if the sidebar is expanded
    const [isExpanded, setIsExpanded] = useState(false);

    // Function to toggle the sidebar state
    const toggleSidebar = () => {
        setIsExpanded(prevState => !prevState);
    };

    const showSidebar = () => setSidebar(!sidebar);

    let logo = getCookie("__ss_us_");
    logo = (getCookie("__ss_us_") === '') ? "" : "/mmbclient/assets/img/" + logo + ".png";

    function showTrackingModalPage() {
        showSidebar();
        store.setTrackingModal(true);
    }

    function handleLog() {
        const confirmed = window.confirm('Are you sure you want to log out?');
        if (confirmed) {
            alert('You have been logged out.');
            clearMasterData(masterData);
            wallet.setWalletAmount(0);
            // Add your logout logic here
            handleLogOut(store);
        } else {
            // alert('Logout canceled.');
        }
    }

    return { isExpanded, toggleSidebar, sidebar, logo, showSidebar, showTrackingModalPage, handleLog };
}

export default SidebarMenuController
